import * as React from "react";
const SvgLengthPipe = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 117.31 96.57",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
	id: "length-pipe_svg__a",
	x1: -5.26,
	x2: 114.11,
	y1: 51.43,
	y2: 51.43,
	gradientTransform: "matrix(.99 .01 .01 .99 4.43 -3.32)",
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: 0,
	stopColor: "#464748"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .15,
	stopColor: "#4c4e4f"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .38,
	stopColor: "#5d6163"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .52,
	stopColor: "#6a6f72"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .69,
	stopColor: "#575a5c"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .86,
	stopColor: "#4b4d4e"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: 1,
	stopColor: "#474849"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "length-pipe_svg__b",
	x1: 12.22,
	x2: 47.87,
	y1: 36,
	y2: 86.79,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .81,
	stopColor: "#424344"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .91,
	stopColor: "#6a6f72"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: 1,
	stopColor: "#4a5157"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__a",
	id: "length-pipe_svg__c",
	x1: 25.27,
	x2: 34.77,
	y1: 61.36,
	y2: 61.36
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__b",
	id: "length-pipe_svg__d",
	x1: 23.51,
	x2: 59.16,
	y1: 28.07,
	y2: 78.86
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__a",
	id: "length-pipe_svg__e",
	x1: 36.32,
	x2: 45.82,
	y1: 53.09,
	y2: 53.09
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__b",
	id: "length-pipe_svg__f",
	x1: 36.12,
	x2: 71.78,
	y1: 19.21,
	y2: 70
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__a",
	id: "length-pipe_svg__g",
	x1: 48.6,
	x2: 62.02,
	y1: 46.54,
	y2: 46.54
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__b",
	id: "length-pipe_svg__h",
	x1: .32,
	x2: 35.98,
	y1: 44.35,
	y2: 95.14
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__a",
	id: "length-pipe_svg__i",
	x1: 13.55,
	x2: 26.98,
	y1: 72.76,
	y2: 72.76
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__b",
	id: "length-pipe_svg__j",
	x1: 48.33,
	x2: 83.98,
	y1: 10.64,
	y2: 61.43
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__a",
	id: "length-pipe_svg__k",
	x1: 60.62,
	x2: 70.12,
	y1: 34.92,
	y2: 34.92
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__b",
	id: "length-pipe_svg__l",
	x1: 59.92,
	x2: 95.57,
	y1: 2.51,
	y2: 53.3
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__a",
	id: "length-pipe_svg__m",
	x1: 71.96,
	x2: 81.46,
	y1: 26.43,
	y2: 26.43
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__b",
	id: "length-pipe_svg__n",
	x1: 72.04,
	x2: 107.69,
	y1: -6,
	y2: 44.79
}), /* @__PURE__ */ React.createElement("linearGradient", {
	xlinkHref: "#length-pipe_svg__a",
	id: "length-pipe_svg__o",
	x1: 83.74,
	x2: 97.17,
	y1: 20.24,
	y2: 20.24
})), /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 1" }, /* @__PURE__ */ React.createElement("path", {
	d: "m95.46 3.81 18 24.11-86.15 64.49a6.58 6.58 0 0 1-9.25-1L3.81 72.38Z",
	style: {
		fill: "none",
		strokeWidth: "5.44px",
		stroke: "url(#length-pipe_svg__a)",
		strokeMiterlimit: 10
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m27.47 57.96 5.1 6.8",
	style: {
		strokeMiterlimit: 10,
		strokeWidth: "5.5px",
		fill: "url(#length-pipe_svg__b)",
		stroke: "url(#length-pipe_svg__c)"
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m38.52 49.69 5.1 6.81",
	style: {
		strokeMiterlimit: 10,
		strokeWidth: "5.5px",
		fill: "url(#length-pipe_svg__d)",
		stroke: "url(#length-pipe_svg__e)"
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m50.8 40.51 9.02 12.06",
	style: {
		strokeMiterlimit: 10,
		strokeWidth: "5.5px",
		fill: "url(#length-pipe_svg__f)",
		stroke: "url(#length-pipe_svg__g)"
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m15.75 66.73 9.02 12.06",
	style: {
		strokeMiterlimit: 10,
		strokeWidth: "5.5px",
		fill: "url(#length-pipe_svg__h)",
		stroke: "url(#length-pipe_svg__i)"
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m62.82 31.51 5.09 6.81",
	style: {
		strokeMiterlimit: 10,
		strokeWidth: "5.5px",
		fill: "url(#length-pipe_svg__j)",
		stroke: "url(#length-pipe_svg__k)"
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m74.16 23.03 5.1 6.8",
	style: {
		strokeMiterlimit: 10,
		strokeWidth: "5.5px",
		fill: "url(#length-pipe_svg__l)",
		stroke: "url(#length-pipe_svg__m)"
	}
}), /* @__PURE__ */ React.createElement("path", {
	d: "m85.95 14.21 9.02 12.06",
	style: {
		strokeMiterlimit: 10,
		strokeWidth: "5.5px",
		fill: "url(#length-pipe_svg__n)",
		stroke: "url(#length-pipe_svg__o)"
	}
}))));
export default SvgLengthPipe;
